export const MOBILE_CONNECTION_START = "MOBILE_CONNECTION_START";
export const MOBILE_CONNECTION_STOP = "MOBILE_CONNECTION_STOP";
export const MOBILE_CONNECTION_STEP_CHANGE = "MOBILE_CONNECTION_STEP_CHANGE";
